import {Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ChangeSetService} from '@emm/core/services/change-set.service';
import {ChangeSet} from '@emm/core/models/change-set.model';
import {FeatureScope} from '@emm/core/util/feature-scope.constants';
import {MenuDateUtil} from '@emm/core/util/menu-date.util';

@Component({
    selector: 'emm-change-sets-dialog',
    styleUrls: ['./change-sets-dialog.component.scss'],
    templateUrl: './change-sets-dialog.component.html'
})
export class ChangeSetsDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    changeSets: any;
    color = '#e5173f';
    diameter = 50;
    mode = 'indeterminate';
    selectedChangeSet: any;
    spinner = true;
    lastChange;
    changeCount: number;

    constructor(
        private changeSetService: ChangeSetService,
        public dialogRef: MatDialogRef<ChangeSetsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {}



    ngOnInit(): void {
        this.getChangeSets();
    }



    getChangeSets(): void {
        const consumer = this.data.consumer;
        const location = this.data.location;
        const date = this.data.effectiveDate;
        const submenu = this.data.submenu;
        const featureScope = this.data.featureScope;
        this.spinner = true;

        let changeSets: Observable<ChangeSet[]>;
        switch (featureScope) {
            case FeatureScope.Viewer:
                changeSets = this.changeSetService.getFutureChangeSetsV4(featureScope, consumer, location, date);
                changeSets.pipe(
                    takeUntilDestroyed(this.destroyRef)
                ).subscribe(res => {
                    this.changeSets = res;
                    this.spinner = false;
                });
                break;
            case FeatureScope.Global:
            case FeatureScope.Client:
                changeSets = this.changeSetService.getFutureChangeSetsV4(featureScope, submenu, location, date);
                changeSets.pipe(
                    takeUntilDestroyed(this.destroyRef)
                ).subscribe(res => {
                    this.changeSets = res;
                    this.spinner = false;
                });
                break;
        }
    }



    onNoClick(): void {
        this.dialogRef.close();
    }



    updateName($event: string, changeSet: ChangeSet): void {
        changeSet.label = $event;
    }


    getChangeCount(effectiveDate): void {
        const consumerOrSubmenu = this.data.consumer ? this.data.consumer : this.data.submenu;
        this.changeSetService
            .getChangeCountV4(this.data.featureScope, consumerOrSubmenu, effectiveDate,
                this.data.location)
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(res => this.changeCount = res);
    }



    getLastChange(effectiveDate): void {
        const consumerOrSubmenu = this.data.consumer ? this.data.consumer : this.data.submenu;
        this.changeSetService
            .getLastChangeV4(this.data.featureScope, consumerOrSubmenu, effectiveDate,
                this.data.location)
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(res => this.lastChange = res.lastPatch);

    }



    openPanel(changeSet: ChangeSet): void {
        this.selectedChangeSet = changeSet;
        this.getChangeCount(changeSet.effectiveDate);
        this.getLastChange(changeSet.effectiveDate);
    }



    closePanel(changeSet: ChangeSet): void {
        if (this.selectedChangeSet === changeSet) {
            this.selectedChangeSet = null;
        }
    }


    atDefaultTimezone(changeSetDate): string {
        return MenuDateUtil.formatDateToDefaultTimezone(changeSetDate);
    }


}
